import { FC } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { FlexboxGrid } from 'rsuite'

import useBuyerCatalogs from '../../../services/useBuyerCatalogs'
import useIsOnMobile from '../../../services/useIsOnMobile'
import CatalogsTable from './CatalogsTable'
import { ScreenSize } from '../../../utils/constants'
import ModifyOrderListButton from './ModifyCatalogButton'
import NoCatalogState from './EmptyStates/NoCatalogState'
import AccountCardsCarousel from '../Account/AccountCardsCarousel'
import MobileViewCatalogList from '../../MyProducts/MobileViewCatalogList'
import ProfileMobileLayout from '../ProfileMobileLayout'

const MyCatalogs: FC = () => {
  const { t } = useTranslation('buyerProfile')

  const { orderLists, isLoading } = useBuyerCatalogs()
  const isOnTablet = useIsOnMobile(ScreenSize.md)
  const isOnLg = useIsOnMobile(ScreenSize.lg)

  const renderCatalog = () => {
    if (!isLoading && orderLists.length) {
      return !isOnTablet ? (
        <>
          <FlexboxGrid
            justify="end"
            className="margin-top-spacer-quadruple"
          >
            <FlexboxGrid.Item>
              <ModifyOrderListButton />
            </FlexboxGrid.Item>
          </FlexboxGrid>
          <CatalogsTable
            data={orderLists}
            isDataLoading={isLoading}
          />
        </>
      )
        : (
          <div className="margin-top-spacer-quadruple">
            <ModifyOrderListButton />
            <MobileViewCatalogList catalogData={orderLists} />
          </div>
        )
    }

    return (
      <NoCatalogState
        headerText={t('No catalogs created')}
        messageText={t('Create a catalog for your location, team or new buyer to easily manage and reorder selected products for your use cases')}
        isLoading={isLoading}
      />
    )
  }

  const getMainContainerClasses = () => {
    if (isOnTablet) {
      return 'margin-spacer-double'
    }

    if (isOnLg) {
      return 'margin-top-spacer-quadruple margin-left-spacer-quadruple margin-right-spacer-quadruple'
    }

    return ''
  }

  return (
    <div className={getMainContainerClasses()}>
      <div
        className={isOnTablet ? 'margin-bottom-spacer-double margin-top-spacer-quadruple' : 'margin-bottom-spacer-tripple'}
      >
        <h1 data-testid="my-catalogs-page-title">
          {t('buyerProfile:My catalogs')}
        </h1>
        {/* Added "buyer-portal-page-subtitle" class selector for Growthbook A/B tests */}
        <p
          className={`${
            isOnTablet ? '' : 'margin-top-spacer'
          } buyer-portal-page-subtitle`}
        >
          {`${t(
            'Use catalogs to order faster, spend smarter, and better manage your supply needs',
          )}.`}
        </p>
      </div>
      {isOnTablet && <ProfileMobileLayout />}
      <AccountCardsCarousel />
      <div>
        {renderCatalog()}
      </div>
    </div>
  )
}

export default MyCatalogs
